module.exports = __webpack_public_path__ + "static/media/red-gold-ribbon-vector.80f2dcd6.svg";